<button class="arrow__button" type="button">
    <app-icon [icon]="direction === 'prev' ? 'arrow-rounded-left-7x11' : 'arrow-rounded-right-7x11'"></app-icon>
</button>
